import { Flex } from 'antd';
import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';

import moduleStyles from 'business/steering/steering.module.scss';
import { ContentTitle } from 'ui/content-title';
import { SimpleCard } from 'ui/SimpleCard';

import styles from './index.module.scss';

interface Props {
  title: string;
  header?: ReactNode;
  filters?: ReactNode;
  fullPage?: boolean;
}

export const SteeringPageTemplate = ({
  title,
  children,
  header,
  filters,
  fullPage = true,
}: PropsWithChildren<Props>) => {
  const innerContent = (
    <Flex
      align="stretch"
      justify="center"
      className={moduleStyles.container}
      vertical
      gap={20}
    >
      <Flex justify="space-between" align="center" className={styles.header}>
        <ContentTitle>{title}</ContentTitle>
        {header}
      </Flex>

      <div className={styles.header}>{filters}</div>

      <SimpleCard>{children}</SimpleCard>
    </Flex>
  );

  return fullPage ? (
    <div className={classNames(moduleStyles.page, 'page-appear')}>
      {innerContent}
    </div>
  ) : (
    innerContent
  );
};
